import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=d5db2302&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=d5db2302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5db2302",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5db2302')) {
      api.createRecord('d5db2302', component.options)
    } else {
      api.reload('d5db2302', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=d5db2302&scoped=true&", function () {
      api.rerender('d5db2302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UvRzcZc7qP00/JS/comp/PopupBox.vue"
export default component.exports